import { combineEpics } from 'redux-observable';
import { fetchProfileEpic, postProfileEpic } from './Profile/epics';
import { registerEpic, loginEpic, logoutEpic } from './Auth/epics';
import { locateEpic, setMapLocationEpic } from './Location/epics';
import { fetchAccountEpic, changeEmailEpic, changePasswordEpic } from './Account/epics';
import { searchEpic } from './Search/epics';
import { fetchPlacesEpic, fetchPlaceEpic, postReviewsEpic } from './Places/epics';
import { dragMapEpic, resultSelectedEpic } from './Map/epics';

export default combineEpics(
    loginEpic, registerEpic, locateEpic, setMapLocationEpic, logoutEpic,
    fetchAccountEpic, changeEmailEpic, changePasswordEpic,
    fetchProfileEpic, postProfileEpic,
    fetchPlacesEpic, fetchPlaceEpic, postReviewsEpic,
    searchEpic, dragMapEpic, resultSelectedEpic
);



// WEBPACK FOOTER //
// ./src/app/models/epics.ts